import { Button } from 'components/Button';
import { Heading } from 'components/Typography';
import { ScheduleContextV4, withScheduleMachineStateV4 } from 'domains/signupv4/schedule/context';
import { useCallback } from 'react';
import { useTranslation } from 'react-i18next';

const ContinueToConsultation: React.FC = () => {
  const { send } = ScheduleContextV4.useActorRef();

  const { t } = useTranslation();

  const handleSubmit = useCallback(() => {
    send({
      type: 'confirmConsultation',
    });
  }, [send]);

  return (
    <>
      <Heading level="h2" className="mb-16">
        {t(`signup.direct.steps.enteringAppointmentType.insurance.continueToConsult.title`)}
      </Heading>

      <Heading level="h7" className="mb-64 sm-d:mb-40">
        {t(`signup.direct.steps.enteringAppointmentType.insurance.continueToConsult.subtitle`)}
      </Heading>

      <Button
        data-testid="appointment-type-submit-button"
        size="lg"
        className="mt-64 sm-d:mt-40 sm-d:w-full"
        onClick={handleSubmit}
      >
        {t(`signup.direct.steps.enterUseInsurance.submit.continue`)}
      </Button>
    </>
  );
};

export const ScheduleV4ContinueToConsultation = withScheduleMachineStateV4(
  ContinueToConsultation,
  'continueToConsultation',
);
